module.exports = __webpack_public_path__ + "fonts/Inter-Regular.76224c7.woff2";